import CrudCustom from '../../../libs/custom/CrudCustom';

let SektorService = new CrudCustom('/sektors');
export default SektorService;
